import { put, select } from 'redux-saga/effects';
import APM from 'js/lib/apmRum';
import { APM_INIT_SUCCESS, APM_INIT_FAIL } from '../actions/apmRum';
import Bugsnag from "@bugsnag/js";

function* initializeApm() {
    try {
        const state = yield select();
        const user = state.claud.get('user');
        APM.setUserContext({
            id: user.usrGuid,
            username: user.userName,
        });
        yield put({ type: APM_INIT_SUCCESS });
    } catch (error) {
        Bugsnag.notify(error);
        yield put({ type: APM_INIT_FAIL, error });
    }
}

export default initializeApm;